import React from 'react';
export function Menu() {
  return <main className="bg-white font-['Averia_Serif_Libre'] pt-24" data-id="element-290">
      <div className="max-w-4xl mx-auto px-6 py-16" data-id="element-291">
        <h1 className="text-5xl md:text-6xl text-center mb-16 leading-tight" data-id="element-292">
          Services Menu
        </h1>
        {/* Neuromodulators */}
        <section className="mb-20" data-id="element-293">
          <h2 className="text-3xl mb-6" data-id="element-294">Neuromodulators</h2>
          <div className="space-y-4" data-id="element-295">
            <ul className="list-disc pl-5 space-y-4" data-id="element-296">
              <li data-id="element-297">
                <strong data-id="element-298">BnTx</strong> (botulinum neurotoxin) has been safely
                used for over 50 years to relax muscles.
              </li>
              <li data-id="element-299">
                Injected into facial muscles to smooth unwanted lines—like frown
                lines or RBF.
              </li>
              <li data-id="element-300">
                My preferred option: <strong data-id="element-301">Xeomin by Merz</strong> —
                preservative-free and clean.
              </li>
              <li data-id="element-302">Results in 1–5 days, lasting 4–6 months.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-303">
              <p className="font-semibold" data-id="element-304">
                Average treatment: <strong data-id="element-305">30–45 units at $11/unit</strong>
              </p>
            </div>
            <ul className="list-disc pl-5" data-id="element-306">
              <li data-id="element-307">Bruising is rare.</li>
            </ul>
            <p className="italic mt-4" data-id="element-308">
              Before/After: Lifted brows and corners of the mouth.
            </p>
          </div>
        </section>
        {/* Fillers */}
        <section className="mb-20" data-id="element-309">
          <h2 className="text-3xl mb-6" data-id="element-310">Fillers</h2>
          <div className="space-y-4" data-id="element-311">
            <ul className="list-disc pl-5 space-y-4" data-id="element-312">
              <li data-id="element-313">
                I use <strong data-id="element-314">biocompatible fillers</strong> made from
                hyaluronic acid or calcium hydroxylapatite.
              </li>
              <li data-id="element-315">
                Used to enhance structure (cheeks) or smooth deep lines (lower
                face).
              </li>
              <li data-id="element-316">Most contain lidocaine for comfort.</li>
              <li data-id="element-317">Bruising is common near the mouth or eyes—plan ahead.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-318">
              <p className="font-semibold" data-id="element-319">
                <strong data-id="element-320">Cost</strong>: $185–$600 per syringe (pay only for what
                you use, except Radiesse)
              </p>
            </div>
            <p className="italic" data-id="element-321">
              Before/After: Filled under-eyes, softened smile lines, sculpted
              cheeks.
            </p>
          </div>
        </section>
        {/* PDO Threads */}
        <section className="mb-20" data-id="element-322">
          <h2 className="text-3xl mb-6" data-id="element-323">PDO Threads</h2>
          <div className="space-y-4" data-id="element-324">
            <ul className="list-disc pl-5 space-y-4" data-id="element-325">
              <li data-id="element-326">
                Made from <strong data-id="element-327">polydioxanone</strong>, these threads
                stimulate collagen and tighten skin.
              </li>
              <li data-id="element-328">
                They dissolve in 4–6 months, leaving firmer, smoother skin.
              </li>
              <li data-id="element-329">
                Thread types:{' '}
                <strong data-id="element-330">
                  lifting (barbs), volumizing (fill), smoothing (monos)
                </strong>
                .
              </li>
              <li data-id="element-331">Lip threads require oral anesthetic; bruising possible.</li>
              <li data-id="element-332">Advance consult and supplement prep required.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-333">
              <p className="font-semibold" data-id="element-334">
                <strong data-id="element-335">Cost</strong>: $800–$1200 for face/jawline lift
              </p>
            </div>
            <p className="italic" data-id="element-336">
              Before/After: Defined jawlines and fuller lips — no filler used.
            </p>
          </div>
        </section>
        {/* Radiesse Bio-Rejuvenation */}
        <section className="mb-20" data-id="element-337">
          <h2 className="text-3xl mb-6" data-id="element-338">Radiesse Bio-Rejuvenation</h2>
          <div className="space-y-4" data-id="element-339">
            <ul className="list-disc pl-5 space-y-4" data-id="element-340">
              <li data-id="element-341">
                <strong data-id="element-342">Radiesse</strong> (calcium hydroxyapatite) stimulates
                collagen and adds fullness.
              </li>
              <li data-id="element-343">Ideal for face, neck, chest, and hands.</li>
              <li data-id="element-344">Fast treatment, minimal downtime.</li>
              <li data-id="element-345">
                <strong data-id="element-346">Radiesse Wash</strong>: thinned for smooth, even spread
                under skin.
              </li>
              <li data-id="element-347">Best for aging, sagging skin support.</li>
            </ul>
            <p className="italic mt-4" data-id="element-348">
              Before/After: Smoother neck and lower face.
            </p>
          </div>
        </section>
        {/* Microneedling */}
        <section className="mb-20" data-id="element-349">
          <h2 className="text-3xl mb-6" data-id="element-350">Microneedling with Stem Cells</h2>
          <div className="space-y-4" data-id="element-351">
            <ul className="list-disc pl-5 space-y-4" data-id="element-352">
              <li data-id="element-353">
                <strong data-id="element-354">Nuova pen</strong> is 3x more effective than standard
                microneedling.
              </li>
              <li data-id="element-355">
                Combined with stem cells + hyaluronic acid for a "wow" effect.
              </li>
              <li data-id="element-356">Treats melasma, acne scars, dull or aging skin.</li>
              <li data-id="element-357">Quick recovery: 20 mins numbing + 24 hrs redness.</li>
              <li data-id="element-358">Results last 1–2 months.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-359">
              <p className="font-semibold" data-id="element-360">
                <strong data-id="element-361">Intro price</strong>: $300 (next 6 months only)
              </p>
            </div>
            <p className="italic bg-gray-50 p-4 rounded-lg" data-id="element-362">
              "Deep stem cell penetration = real results — Nuova makes it
              possible."
            </p>
          </div>
        </section>
        {/* Products Section */}
        <section className="mb-20" data-id="element-363">
          <h2 className="text-3xl mb-12 text-center" data-id="element-364">Products I like....</h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-365">
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg" data-id="element-366">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8WE2NdqHefYZJYZg4AjQQk/Screenshot_2025-04-17_at_10.57.50_AM.png" alt="Tretinoin Cream" className="w-full h-48 object-contain mb-4" data-id="element-367" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-368">Tretinoin 0.1%</h3>
              <p className="mb-4 text-sm leading-relaxed" data-id="element-369">
                Tretinoin is the one most-advised skin cream by dermatologists.
                It speeds cell turnover and clears pores, leaving skin clear and
                pores clean. Originally developed for acne, it is great at any
                age. Talk to me about how often YOU would use it, as frequency
                varies with skin type.
              </p>
              <p className="font-semibold" data-id="element-370">Fight Club price $80</p>
            </div>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg" data-id="element-371">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8WE2NdqHefYZJYZg4AjQQk/Screenshot_2025-04-17_at_10.57.50_AM.png" alt="Nu-Cil Eyelash serum" className="w-full h-48 object-contain mb-4" data-id="element-372" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-373">
                Nu-Cil Eyelash serum
              </h3>
              <p className="mb-4 text-sm leading-relaxed" data-id="element-374">
                Use of this eyelash twice daily results in proven longer &
                darker eyelashes. I saw a noticeable difference in a week - and
                it works without the prostaglandins other serums have which
                cause a dark ring around the iris.
              </p>
              <p className="font-semibold" data-id="element-375">FC price $80</p>
            </div>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg" data-id="element-376">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8WE2NdqHefYZJYZg4AjQQk/Screenshot_2025-04-17_at_10.57.50_AM.png" alt="ELASTIderm eye serum" className="w-full h-48 object-contain mb-4" data-id="element-377" />
              <h3 className="text-xl font-semibold mb-3" data-id="element-378">
                ELASTIderm eye serum
              </h3>
              <p className="mb-4 text-sm leading-relaxed" data-id="element-379">
                I love this rollerball serum! It contains bi-minerals and
                malonic acid for skin smoothing, but the real trick ingredient
                is caffeine to help minimize puffiness and shrink capillaries
                around the eyes. Use it twice a day.
              </p>
              <p className="font-semibold" data-id="element-380">FC price $85</p>
            </div>
          </div>
        </section>
      </div>
    </main>;
}